document.addEventListener("DOMContentLoaded", function () {
    const gridViewBtn = document.getElementById("grid-view-btn");
    const listViewBtn = document.getElementById("list-view-btn");
    const listIcon = document.getElementById("icon-list");
    const gridIcon = document.getElementById("icon-grid");
    const imageToggleBtn = document.getElementById("image-toggle-btn");
    const imageIcon = document.getElementById("image-icon");

    const updateImageViewIcon = (state) => {
        const imageContainers = document.querySelectorAll(
            ".card-image-selector"
        );
        const articleImageContainers = document.querySelectorAll(
            ".article-card-image"
        );
        const infoContainers = document.querySelectorAll(
            ".card__information"
        );

        if (state === "images-on") {
            imageIcon.className = "icon-wrapper icon-image";
            imageContainers?.forEach((card) => card.classList.remove("hidden"));
            articleImageContainers?.forEach((card) => card.classList.remove("hidden"));
            infoContainers?.forEach((infoCard) => infoCard.classList.remove("image-hidden"));
        } else {
            imageIcon.className = "icon-wrapper icon-no-image";
            imageContainers?.forEach((card) => card.classList.add("hidden"));
            articleImageContainers?.forEach((card) => card.classList.add("hidden"));
            infoContainers?.forEach((infoCard) => infoCard.classList.add("image-hidden"));
        }
    };

    const updateViewTypeIcon = (state) => {
        const collectionsContainer = document.getElementById("product-grid");
        const collectionsCards = document.querySelectorAll(
            ".product-card-selector"
        );

        if (!collectionsContainer) return;

        if (state === "grid-view") {
            gridIcon.setAttribute("fill", "#d8352b");
            listIcon.setAttribute("stroke", "#000000");

            collectionsContainer.classList.remove("list-view");
            collectionsContainer.classList.add("grid");

            collectionsCards?.forEach((card) => {
                card.classList.remove("list-view-card");
                card.classList.add("grid__item");
            });
        } else {
            gridIcon.setAttribute("fill", "#000000");
            listIcon.setAttribute("stroke", "#d8352b");

            collectionsContainer.classList.remove("grid");
            collectionsContainer.classList.add("list-view");

            collectionsCards?.forEach((card) => {
                card.classList.remove("grid__item");
                card.classList.add("list-view-card");
            });
        }
    };

    const applySavedViewSettings = () => {
        const savedViewMode = localStorage.getItem("viewMode") || "grid-view";
        const savedImageState =
            localStorage.getItem("imageState") || "images-on";
        updateImageViewIcon(savedImageState);
        updateViewTypeIcon(savedViewMode);
    };

    // Reapply saved settings on DOM updates
    const observer = new MutationObserver(() => {
        applySavedViewSettings();
    });

    const productGridContainer = document.getElementById(
        "ProductGridContainer"
    );
    if (productGridContainer) {
        observer.observe(productGridContainer, {
            childList: true,
            subtree: true,
        });
    }

    // View toggle buttons
    gridViewBtn.addEventListener("click", function () {
        updateViewTypeIcon("grid-view");
        localStorage.setItem("viewMode", "grid-view");
    });

    listViewBtn.addEventListener("click", function () {
        updateViewTypeIcon("list-view");
        localStorage.setItem("viewMode", "list-view");
    });
    let isImagesOn =
        localStorage.getItem("imageState") === "images-on" ? true : false;

    imageToggleBtn.addEventListener("click", function () {
        isImagesOn = !isImagesOn;
        imageIcon.className = `icon-wrapper ${
            isImagesOn ? "icon-image" : "icon-no-image"
        }`;

        const imageState = isImagesOn ? "images-on" : "images-off";
        updateImageViewIcon(imageState);
        localStorage.setItem("imageState", imageState);
    });
    // Initial settings
    applySavedViewSettings();
});
